import { ReactFlowProvider } from "@xyflow/react"
import Root from "./root.component"

export const RootProvider = (props: any) => {
    return <ReactFlowProvider>
        <Root />
    </ReactFlowProvider>
}